import { RootState } from '../models';

export const selectCurrentTime = (state: RootState) => state.video.currentTime;